import { Link } from '@framework/router/Next/Link';
import Flex from '@creditflowresearch/uilib/Flex';
import Button from '@creditflowresearch/uilib/Button';
import LogInButton from '@/creditflowresearch/ui/common/components/LogInButton';
import useSignUpUrl from '@/creditflowresearch/application/hooks/useSignUpUrl';

import styles from './loginOrSignUpPopover.module.scss';

const PopoverContent = () => {
  const signUpUrl = useSignUpUrl();

  return (
    <Flex direction="column" justify="space-between" align="center" gap={ 10 }>
      <span className={ styles.popoverDescription }>
        Login or create a free CFR account to get access.
      </span>
      <Flex justify="space-between" align="center" gap={ 10 }>
        <LogInButton
          withIcon={ false }
          variant="outline"
          buttonSize="S"
          className={ styles.loginButton }
        />
        <Button
          as={ Link }
          to={ signUpUrl }
          dataTest="freeSignUpButton"
          size="S"
          color="gradient"
        >
          Free Sign Up
        </Button>
      </Flex>
    </Flex>
  );
};

export default PopoverContent;
